import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';

const DevelopmentBanner: React.FC = () => {
  const { t, language } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-saudi-gold-400 via-saudi-gold-500 to-saudi-gold-600 text-white py-3 px-4 relative z-50 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          {/* @ts-expect-error - react-icons compatibility with React 19 */}
          <FaExclamationTriangle className="flex-shrink-0" size={20} />
          <p className="text-sm md:text-base font-semibold">
            {language === 'en' 
              ? '🚧 Website Under Development - Some features may be unavailable'
              : '🚧 الموقع قيد التطوير - قد تكون بعض الميزات غير متاحة'}
          </p>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="flex-shrink-0 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label={language === 'en' ? 'Close banner' : 'إغلاق الشعار'}
        >
          {/* @ts-expect-error - react-icons compatibility with React 19 */}
          <FaTimes size={18} />
        </button>
      </div>
    </div>
  );
};

export default DevelopmentBanner;

